import { LoadSpecialties } from 'domain/usecases/specialties/load-specialties'
import { SpecialtyRepository } from 'repository/interfaces/specialty-repository'

export class RemoteLoadSpecialties implements LoadSpecialties {
  private readonly specialtyRepository: SpecialtyRepository

  constructor(specialtyRepository: SpecialtyRepository) {
    this.specialtyRepository = specialtyRepository
  }

  load(params: LoadSpecialties.Params): Promise<LoadSpecialties.Model> {
    return this.specialtyRepository.loadSpecialties(params)
  }
}
